import { StoreLineItem } from './interface';
import {
  LineItem as ProtoLineItem,
  ProductInterface,
  LineItems as ProtoLineItems,
  Package as ProtoPackage,
  Pricing as ProtoPricing,
  Currency as ProtoCurrency,
  MarketAction,
} from '@vendasta/marketplace-packages';
import { Price, Pricing } from '../pricing/pricing';
import { File } from '../files/shared/file.model';

export class PackageDetails {
  solution_id: string;
  partner_id: string;
  market_id: string;
  name: string;
  icon: string;
  status: string;
  tagline: string;
  header_image_url: string;
  content: string;
  hide_product_icons_and_names: boolean;
  hide_product_details: boolean;
  createdDate: Date;
  updatedDate: Date;
  pricing: Pricing;
  line_items: StoreLineItem[];
  market_action: MarketAction;

  get isPackageFree(): boolean {
    const isFreeHelper = (prices: Price[]): boolean => {
      return prices ? prices.some((p) => p.price === 0 || p.price === undefined) : false;
    };
    return this.pricing && isFreeHelper(this.pricing.prices);
  }
}

export function convertToPackageDetails(data: ProtoPackage, products: ProductInterface[]): PackageDetails {
  if (!data) {
    return undefined;
  }

  const newPackage = new PackageDetails();
  if (!data.pricing) {
    data.pricing = ProtoPricing.fromProto({
      currency: undefined,
      prices: [
        {
          price: 0,
          frequency: undefined,
          isStartingPrice: false,
        },
      ],
    });
  }

  Object.assign(newPackage, data);

  if (!newPackage.name) {
    newPackage.name = 'Untitled';
  }
  if (data.created) {
    newPackage.createdDate = new Date(data.created);
  }
  if (data.updated) {
    newPackage.updatedDate = new Date(data.updated);
  }
  if (data.lineItems) {
    newPackage.line_items = convertProtoLineItemsToStoreLineItems(data.lineItems, products);
  }
  if (typeof data.pricing.currency === 'number') {
    newPackage.pricing.currency = ProtoCurrency[data.pricing.currency];
  }

  return newPackage;
}

export function convertProtoLineItemsToStoreLineItems(
  protoLineItems: ProtoLineItems,
  products: ProductInterface[],
): StoreLineItem[] {
  if (
    !protoLineItems ||
    !protoLineItems.lineItems ||
    protoLineItems.lineItems.length === 0 ||
    !products ||
    products.length === 0
  ) {
    return [];
  }
  return protoLineItems.lineItems.map((lineItem) => {
    const product = products.find((p) => p.productId === lineItem.id);
    let parent;
    if (lineItem.parentId) {
      parent = products.find((p) => p.productId === lineItem.parentId);
    }
    return convertProtoLineItemToStoreLineItem(lineItem, product, parent);
  });
}

function convertProtoLineItemToStoreLineItem(
  protoLineItem: ProtoLineItem,
  product: ProductInterface,
  parentProduct?: ProductInterface,
): StoreLineItem {
  if (!product || !protoLineItem) {
    return undefined;
  }

  let files = [];
  if (product.pdfUploadUrls && product.pdfUploadUrls.length > 0) {
    files = product.pdfUploadUrls.map((url) => new File(url));
  }

  const lineItem = {
    item: {
      id: protoLineItem.id,
      editionId: protoLineItem.editionId,
      icon: product.iconUrl,
      name: product.name,
      editionName: '',
      description: product.description,
      keySellingPoints: product.keySellingPoints,
      faqs: product.faqs,
      files: files,
      screenshotUrls: product.screenshotUrls,
      lmiCategories: [],
    },
    quantity: protoLineItem.quantity,
    parent: {},
  } as StoreLineItem;

  if (protoLineItem.parentId && parentProduct) {
    lineItem.parent = {
      id: protoLineItem.parentId,
      editionId: '',
      icon: parentProduct.iconUrl,
      name: parentProduct.name,
      editionName: '',
    };
  }
  return lineItem;
}
